import axios, { resHandle } from "@/plugins/axios";



/**
 * @description 质量控制: 诊次列表
 * @param vCom Vue组件
 */
const GetZlkzZhenciList = (vCom: any, params): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.post("api/center/zlkz/patients", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            });
        }).catch(() => {
            reject();
        });
    });
};


// 2.0功能
/**
 * @description 提交审核
 * @param vCom Vue组件
 */
const TijiaoShenhe = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.post("api/center/tijiao", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            }).catch((err) => {
                reject(err);
            });
        }).catch((err) => {
            reject(err);
        });
    });
};

/**
 * @description 质量控制: 单个质疑详情
 * @param vCom Vue组件
 */
const DangeZhiyi = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.get("api/center/zhiyi", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            }).catch((err) => {
                reject(err);
            });
        }).catch((err) => {
            reject(err);
        });
    });
};

/**
 * @description 质量控制: 提交质疑
 * @param vCom Vue组件
 */
const Tijiaozhiyi = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.post("api/center/zhiyi", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            }).catch((err) => {
                reject(err);
            });
        }).catch((err) => {
            reject(err);
        });
    });
};

/**
 * @description 质量控制: 质疑记录
 * @param vCom Vue组件
 */
const Zhiyijilu = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.get("api/center/zhiyis", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            }).catch((err) => {
                reject(err);
            });
        }).catch((err) => {
            reject(err);
        });
    });
};


/**
 * @description 监查痕迹列表
 * @param vCom Vue组件
 */
const JianchaHengjiList = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.post("api/center/jianchas", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            }).catch((err) => {
                reject(err);
            });
        }).catch((err) => {
            reject(err);
        });
    });
};

/**
 * @description 质量控制: 审核
 * @param vCom Vue组件
 */
const Shenhetongguo = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.post("api/center/shenhe", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            }).catch((err) => {
                reject(err);
            });
        }).catch((err) => {
            reject(err);
        });
    });
};



/**
 * @description 监查痕迹: 诊次下来列表
 * @param vCom Vue组件
 */
const ZhenciList = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.post("api/center/jiancha/zhencis", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            }).catch((err) => {
                reject(err);
            });
        }).catch((err) => {
            reject(err);
        });
    });
};

/**
 * @description 监查痕迹: 单个诊次的监查痕迹
 * @param vCom Vue组件
 */
const ZhenciJianchaList = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.get("api/center/jiancha", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            }).catch((err) => {
                reject(err);
            });
        }).catch((err) => {
            reject(err);
        });
    });
};

export {
    GetZlkzZhenciList,
    TijiaoShenhe, DangeZhiyi, Tijiaozhiyi, Zhiyijilu, Shenhetongguo,
    JianchaHengjiList, ZhenciList, ZhenciJianchaList
};

